import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"



const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  isExpired,
  ...rest
}) => (


  <Route

    {...rest}
    render={props => {


      //if authToken is expired then remove it from localStorage and redirect to login page
      if (isExpired) {
        localStorage.removeItem("authUser")
        localStorage.removeItem("authToken")
        alert("Your session has expired. Please login again.")
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }

      if (isAuthProtected && !localStorage.getItem("authUser")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
      if (isAuthProtected && localStorage.getItem("authPark")) {
        return (
          <Redirect
            to={{ pathname: "/auth-lock-screen", state: { from: props.location } }}
          />
        )
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }}
  />
)

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware;
